export default __webpack_public_path__ + "static/media/blog-post-layout-03-img-01.05a7f3b8.jpg";